import { ActionIcon, Loader, Tooltip } from '@mantine/core'
import { IconMailShare } from '@tabler/icons-react'
import { useState } from 'react'
import { showNotification } from '@mantine/notifications'
import type { Patient } from '@medplum/fhirtypes'
import { useMiddlewareClient } from '@/hooks/useMiddlewareClient'
import { usePatient } from '@/hooks/usePatient'
import { pillTooltipProps } from './pillTooltip'

export function ResendInvitationButton({ patient }: { patient: Patient }) {
  const middleware = useMiddlewareClient()
  const [isResending, setIsResending] = useState(false)
  const { data: patientData, refresh } = usePatient(patient.id)

  const handleResend = async () => {
    setIsResending(true)
    try {
      await middleware.post('/patient/invite', { resource: patient })
      await refresh()
      showNotification({
        color: 'green',
        message: 'Invitation resent successfully',
      })
    } catch (error) {
      showNotification({
        color: 'red',
        message: (error as Error).message || 'Resend invitation failed',
      })
    } finally {
      setIsResending(false)
    }
  }

  return (
    <Tooltip
      label={
        (patientData?.status ?? 'invited') !== 'invited'
          ? 'Resend invitation with password reset link'
          : 'Resend invitation'
      }
      {...pillTooltipProps}
    >
      <ActionIcon
        variant="subtle"
        color="gray"
        radius="md"
        size={30}
        style={{ border: 'none' }}
        onClick={handleResend}
        disabled={isResending}
        aria-label="Resend portal invitation"
      >
        {isResending ? <Loader size={18} color="gray" /> : <IconMailShare size={21} stroke={1.6} />}
      </ActionIcon>
    </Tooltip>
  )
}
